"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Smoothy = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const SMOOTHY_ABI = require("../../abi/smoothyV1.abi.json");
class Smoothy extends adapter_1.default {
    static getDexData(optimalRate, name) {
        const { srcAmount, data: { exchange, i, j }, } = optimalRate;
        return {
            name,
            srcAmount,
            destAmount: '1',
            i,
            j,
            exchange,
        };
    }
    _swap(srcToken, destToken, data) {
        const { exchange, i, j } = data;
        const smoothyContract = new this.web3Provider.eth.Contract(SMOOTHY_ABI, exchange);
        const swapData = smoothyContract.methods
            .swap(i, j, data.srcAmount, data.destAmount)
            .encodeABI();
        return super.swap(srcToken, destToken, data, swapData, exchange);
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._swap(srcToken, destToken, data);
        });
    }
}
exports.Smoothy = Smoothy;
//# sourceMappingURL=smoothy.js.map